import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function Gallery() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-espresso text-cream overflow-hidden relative" data-id="element-107">
      {/* Decorative warm glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[60%] bg-caramel/10 rounded-full blur-3xl pointer-events-none" data-id="element-108" />

      <div className="max-w-6xl mx-auto relative" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-110">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-caramel/20 text-caramel-light font-medium text-sm mb-6 border border-caramel/30" data-id="element-111">
            <Sparkles className="w-4 h-4" data-id="element-112" />
            Productos Estrella
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4 text-white leading-tight" data-id="element-113">
            Imagina crear{' '}
            <span className="italic text-caramel-light" data-id="element-114">esto</span> en tu propia
            cocina
          </h2>
          <p className="text-cream-dark/80 font-sans max-w-2xl mx-auto text-lg" data-id="element-115">
            Milhojas crujientes con crema sedosa y galletas estilo New York con
            chocolate derretido. Resultados dignos de una vitrina de alta
            pastelería, hechos por ti.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative max-w-3xl mx-auto" data-id="element-116">
          {/* Soft glow behind image */}
          <div className="absolute -inset-4 bg-gradient-to-br from-caramel/30 via-rose/20 to-caramel/30 rounded-[2.5rem] blur-2xl opacity-60" data-id="element-117" />

          <div className="relative rounded-[2rem] overflow-hidden shadow-2xl border-4 border-caramel/20" data-id="element-118">
            <img src="https://cdn.magicpatterns.com/uploads/xk9vPM9N9zQ9LAW3nmCqHK/Copilot_20260529_222433.png" alt="Milhoja con crema pastelera y galletas con chispas de chocolate" width={768} height={1024} loading="lazy" decoding="async" className="w-full h-auto object-cover block" data-id="element-119" />
          </div>

          {/* Floating accent labels */}
          <motion.div animate={{
          y: [0, -8, 0]
        }} transition={{
          repeat: Infinity,
          duration: 4,
          ease: 'easeInOut'
        }} className="hidden md:flex absolute -left-4 lg:-left-12 top-1/4 bg-white text-espresso px-4 py-3 rounded-2xl shadow-xl items-center gap-2 border border-caramel/20" data-id="element-120">
            <span className="text-2xl" data-id="element-121">🥮</span>
            <div className="text-left" data-id="element-122">
              <div className="font-serif font-bold text-sm" data-id="element-123">Milhoja</div>
              <div className="text-xs text-espresso-light" data-id="element-124">
                Hojaldre perfecto
              </div>
            </div>
          </motion.div>

          <motion.div animate={{
          y: [0, 8, 0]
        }} transition={{
          repeat: Infinity,
          duration: 4,
          ease: 'easeInOut',
          delay: 1
        }} className="hidden md:flex absolute -right-4 lg:-right-12 bottom-1/4 bg-white text-espresso px-4 py-3 rounded-2xl shadow-xl items-center gap-2 border border-caramel/20" data-id="element-125">
            <span className="text-2xl" data-id="element-126">🍪</span>
            <div className="text-left" data-id="element-127">
              <div className="font-serif font-bold text-sm" data-id="element-128">Galleta NY</div>
              <div className="text-xs text-espresso-light" data-id="element-129">
                Chocolate derretido
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}